import React from "react"
import { ui } from "../../../shared/styles/uiSystem"

export default function HeldReservationDrawer({
  reservation,
  onConfirm,
  onCancel,
  onClose
}) {
  if (!reservation) return null

  const patientName = reservation.patientName || "Paciente no identificado"
  const startLabel = reservation.start
    ? new Date(reservation.start).toLocaleString("es-MX")
    : "-"
  const endLabel = reservation.end
    ? new Date(reservation.end).toLocaleString("es-MX")
    : "-"

  return (
    <div
      style={{
        position: "fixed",
        bottom: 20,
        left: 20,
        width: 400,
        maxWidth: "calc(100vw - 24px)",
        zIndex: 9999
      }}
    >
      <div
        style={{
          ...ui.card,
          padding: 16,
          borderLeft: "4px solid #f59e0b",
          boxShadow: "0 18px 36px rgba(15,23,42,0.14)"
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: 10,
            alignItems: "flex-start",
            marginBottom: 12
          }}
        >
          <div>
            <div
              style={{
                display: "inline-flex",
                padding: "5px 9px",
                borderRadius: 999,
                background: "#fff7ed",
                border: "1px solid #fed7aa",
                color: "#c2410c",
                fontSize: 10,
                fontWeight: 900,
                letterSpacing: 0.5,
                textTransform: "uppercase",
                marginBottom: 8
              }}
            >
              Reserva temporal
            </div>

            <div
              style={{
                fontSize: 18,
                fontWeight: 900,
                color: "#0f172a",
                lineHeight: 1.1
              }}
            >
              {patientName}
            </div>
          </div>

          <button
            onClick={onClose}
            style={{
              ...ui.secondaryButton,
              minHeight: 32,
              padding: "0 10px"
            }}
          >
            Cerrar
          </button>
        </div>

        <div style={{ display: "grid", gap: 10 }}>
          <InfoRow label="Doctor" value={reservation.doctorName || "Sin doctor"} />
          <InfoRow label="Motivo" value={reservation.reason || "Reserva temporal"} />
          <InfoRow label="Inicio" value={startLabel} />
          <InfoRow label="Fin" value={endLabel} />
        </div>

        <div
          style={{
            display: "flex",
            gap: 8,
            flexWrap: "wrap",
            marginTop: 14
          }}
        >
          <button
            onClick={onConfirm}
            style={{
              ...ui.secondaryButton,
              background: "#dcfce7",
              border: "1px solid #bbf7d0",
              color: "#166534"
            }}
          >
            Confirmar
          </button>

          <button
            onClick={onCancel}
            style={{
              ...ui.secondaryButton,
              background: "#fee2e2",
              border: "1px solid #fecaca",
              color: "#991b1b"
            }}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  )
}

function InfoRow({ label, value }) {
  return (
    <div
      style={{
        ...ui.softCard,
        padding: 10,
        display: "grid",
        gridTemplateColumns: "72px minmax(0, 1fr)",
        gap: 10,
        alignItems: "start"
      }}
    >
      <div
        style={{
          fontSize: 11,
          color: "#64748b",
          fontWeight: 800
        }}
      >
        {label}
      </div>

      <div
        style={{
          fontSize: 13,
          color: "#0f172a",
          fontWeight: 700,
          lineHeight: 1.35,
          wordBreak: "break-word"
        }}
      >
        {value}
      </div>
    </div>
  )
}